import { useQuery } from "@tanstack/react-query";
import { usePassport } from '../../../hooks/usePassport';

const MissionDetailPage = ({ exploreCode, setExploreCode }) => {
	const API_URL = import.meta.env.VITE_API_URL;
	const { passport } = usePassport();

	const { data } = useQuery({
		queryKey: ['explore'],
		queryFn: async () => {
			const response = await fetch(`${API_URL}/bbs/ajax.get_explore.php`);
			return response.json();
		}
	});
	const items = data?.data?.list ?? null;

  return (
    <div className="bg-slate-100 p-10 min-h-screen flex justify-center items-start">
      {/* .boarding-pass 
        티켓 양 옆의 홈(홈) 효과를 위해 before, after 가상 요소 사용
      */}
      <div className="
        relative w-full bg-white p-[30px] m-[20px]
        border-[3px] border-dashed border-slate-400 rounded-[15px]
        before:content-[''] before:absolute before:w-[30px] before:height-[30px] before:h-[30px]
        before:bg-slate-100 before:rounded-full before:border-[3px] before:border-slate-400
        before:top-1/2 before:-translate-y-1/2 before:-left-[18px]
        after:content-[''] after:absolute after:w-[30px] after:height-[30px] after:h-[30px]
        after:bg-slate-100 after:rounded-full after:border-[3px] after:border-slate-400
        after:top-1/2 after:-translate-y-1/2 after:-right-[18px]
      ">
        
        {/* .visa-stamp (애니메이션 포함) */}
        <div className="
          absolute top-5 right-5 w-[120px] h-[120px] 
          border-4 border-emerald-600 rounded-full 
          bg-emerald-600/10 text-emerald-600 
          flex flex-col items-center justify-center 
          font-bold -rotate-[15deg] z-10
          animate-[stampPop_0.5s_ease]
        ">
          <div className="text-3xl mb-1">✓</div>
          <div className="text-sm">APPROVED</div>
          <div className="text-xs">2026. 4. 16.</div>
        </div>

        {/* Header Section */}
        <div className="flex justify-between items-center mb-5 pb-5 border-b-[3px] border-dashed border-slate-200">
          <div>
            <div className="text-[48px] font-[900] text-blue-800 leading-none">➗</div>
            <div className="text-[14px] text-slate-500 font-bold">MTH</div>
          </div>
          <div className="text-[36px] text-slate-400">✈️</div>
          <div className="text-right">
            <div className="text-[24px] font-bold text-blue-900">숫자나라</div>
          </div>
        </div>

        {/* .mission-grid & .mission-stamp */}
        <div className="mb-5">
          <div className="flex justify-between text-[12px] mb-2 font-bold">
            <span>미션 스탬프</span>
            <span className="text-red-500 font-bold">5 / 5</span>
          </div>
          <div className="grid grid-cols-5 gap-[10px] my-5">
            {[1, 2, 3, 4, 5].map((i) => (
              <div 
                key={i} 
                className="aspect-square border-[3px] border-amber-500 rounded-lg flex items-center justify-center text-[28px] bg-gradient-to-br from-amber-50 to-yellow-300 shadow-[0_4px_10px_rgba(245,158,11,0.3)] transition-all"
              >
                ⭐
              </div>
            ))}
          </div>
        </div>

        {/* Mission List */}
        <div className="max-h-[280px] overflow-y-auto mb-5 space-y-[10px]">
          {[
            "1. 실생활 수학 문제 은행",
            "2. 데이터 분석 프로젝트",
            "3. 알고리즘 패턴 연구",
            "4. 기하학 예술 작품",
            "5. 수학 올림피아드 준비"
          ].map((text, idx) => (
            <div key={idx} className="p-[10px] bg-emerald-50 border-2 border-emerald-500 rounded-lg flex justify-between items-center">
              <div className="font-bold text-[13px]">{text}</div>
              <div className="text-emerald-500 text-[12px] font-bold whitespace-nowrap ml-2">✓ 완료</div>
            </div>
          ))}
        </div>

        {/* Special Badge Section */}
        <div className="p-5 bg-gradient-to-br from-amber-50 to-yellow-200 rounded-xl border-2 border-amber-500">
          <div className="font-bold mb-3 text-amber-900 text-[14px]">🏅 숫자나라 특별 배지</div>
          <div className="grid grid-cols-2 gap-2">
            {[
              { icon: "🏃", name: "스피드러너" },
              { icon: "🎯", name: "완벽주의자" },
              { icon: "🎤", name: "발표왕" },
              { icon: "🔥", name: "열정왕" }
            ].map((badge, idx) => (
              <div key={idx} className="p-[10px] bg-white border-2 border-slate-300 rounded-lg text-center">
                <div className="text-[28px] mb-1">{badge.icon}</div>
                <div className="text-[10px] font-bold text-slate-500">{badge.name}</div>
              </div>
            ))}
          </div>
          <div className="mt-3 text-center text-[11px] font-bold text-amber-900">
            획득한 배지: 0 / 4
          </div>
        </div>
      </div>

      {/* Tailwind Animation Keyframes (CSS 파일이나 커스텀 설정 필요) */}
      <style>{`
        @keyframes stampPop {
          0% { transform: rotate(-15deg) scale(0); }
          50% { transform: rotate(-15deg) scale(1.2); }
          100% { transform: rotate(-15deg) scale(1); }
        }
      `}</style>
    </div>
	);
}

export default MissionDetailPage;